{
  "users": {
    "navigation_title": "Usuarios",
    "title": "Usuarios",
    "list_title": "Usuarios",
    "list": {
      "title": "Lista",
      "delete": {
        "itself": "Lo sentimos. No puede borrarse a sí mismo"
      }
    },
    "edit": "Editar Perfil",
    "filter_input": "Filtrar usuarios...",
    "invitations_filter_input": "Filtrar invitaciones...",
    "edit_profile": "Editar perfil",
    "profile_title": "Perfil",
    "notifications": "Notificaciones",
    "access": "Acceso",
    "reset_password": "Restablecer Contraseña",
    "form_title": "Usuario",
    "create_new": "Nuevo usuario",
    "save": "Guardar",
    "go_to_index": "Regresar a los usuarios",
    "error_settings": "¡Revise su configuración!",
    "user_password_succesfull_update": "Su contraseña ha cambiado",
    "remove_role": "Remover función",
    "remove_user_role_confirmation": {
      "text": "Está a punto de eliminar el rol %{role} en %{name} para %{email}. ¿Está seguro de que desea continuar?",
      "cancel": "Cancelar",
      "confirm": "Confirmar"
    },
    "remove_role_confirmation": {
      "text": "Está a punto de eliminar el rol %{role} en %{name}. ¿Está seguro de que desea continuar?",
      "cancel": "Cancelar",
      "confirm": "Confirmar"
    },
    "delete_user": "Eliminar usuario",
    "delete_user_confirmation": {
      "text": "Está a punto de eliminar permanentemente a %{email}. ¿Está seguro de que desea continuar?"
    },
    "organization_roles": "Funciones de la organización",
    "project_roles": "Roles de Proyecto",
    "add_role": "Agregar función",
    "roles_title": "Acceso",
    "manage_roles": "Administrar funciones",
    "user_details": "Información del usuario",
    "invite_new_user": "Invitar usuario",
    "sent_invitation": "Enviar invitaciones",
    "save_roles": "Guardar funciones",
    "select_user": "Seleccionar usuario",
    "admin_user": "Este usuario es un administrador",
    "support_user": "Este usuario es parte del soporte",
    "organization_levels": {
      "executive": "Ejecutivo",
      "director": "Director",
      "manager": "Administrador",
      "sales": "Ventas",
      "technical": "Técnico"
    },
    "states": {
      "online": "En línea",
      "offline": "Fuera de línea"
    },
    "notices": {
      "email_digest": "Resumen del correo electrónico",
      "email": "Correo electrónico",
      "sms": "SMS",
      "email_sms": "Correo electrónico + SMS",
      "critical_level": "Nivel crítico",
      "warning_level": "Nivel de advertencia",
      "info_level": "Información del nivel",
      "alert": "Alerta",
      "message": "Mensaje",
      "organization_request": "Solicitud de la organización",
      "membership": "Membresía"
    },
    "roles": {
      "manager": "administrador",
      "manager_at": "Administrador en %{org_name}",
      "user": "usuario",
      "user_at": "Usuario en %{org_name}",
      "owner": "propietario",
      "owner_at": "Propietario en %{org_name}",
      "support": "Soporte",
      "accountant": "contador",
      "accountant_at": "Contador en %{org_name}",
      "admin": "Administrador",
      "admin_at": "Administrador en %{org_name}",
      "default_option": "Seleccionar función.."
    },
    "notifying_methods": {
      "email": "Correo electrónico",
      "sms": "SMS"
    },
    "notifying_types": {
      "formation_request": "Nueva solicitud de la organización",
      "message": "Mensaje",
      "partnership": "Organización del asociado",
      "membership": "Membresía de la organización",
      "alert": "Alerta"
    },
    "notifying_levels": {
      "critical": "Crítico",
      "warning": "Advertencia",
      "info": "Información"
    },
    "more_info": {
      "contact_info": "Información de contacto",
      "office": "Oficina",
      "mobile": "Celular",
      "company_address": "Dirección de la empresa",
      "language": "Idioma"
    },
    "grid": {
      "qr_code": "Código QR",
      "user_picture": "Foto del usuario"
    },
    "access_form": {
      "title": "Acceso",
      "organization": "Organización",
      "role": "Rol",
      "remove": "Quitar de la organización",
      "undo": "Deshacer",
      "locked": "Solo un propietario puede cambiar a un %{role}",
      "no_roles": "Sin roles en organizaciones.",
      "save": "Guardar cambios",
      "saved": "Acceso guardado",
      "failed": "Algunos cambios no se guardaron. Siguen en la página.",
      "manage_access": "Gestionar acceso",
      "not_found": "Este usuario no está en tus organizaciones."
    }
  }
}
